import { capitalCase } from 'change-case';
import { Option } from '~/components/Multiselect';

export default function enumToOptions<T extends string>(enumObj: Record<string, T>): Option<T>[] {
  return Object.values(enumObj).map((i) => ({ value: i, label: capitalCase(i as string) }));
}
